var map = {
	"./SiteHeader.js": 372,
	"./alert_messages.js": 673,
	"./bootstrap_file_upload.js": 175,
	"./components/submission_tag.js": 786,
	"./csrf_token.js": 726,
	"./index.js": 440,
	"./modal.js": 33,
	"./popup_menu.js": 346,
	"./selected_submission_tags.js": 244,
	"./taggable_submission_text.js": 494,
	"./tagged_submission_text.js": 791,
	"modules/SiteHeader.js": 372,
	"modules/alert_messages.js": 673,
	"modules/bootstrap_file_upload.js": 175,
	"modules/components/submission_tag.js": 786,
	"modules/csrf_token.js": 726,
	"modules/index.js": 440,
	"modules/modal.js": 33,
	"modules/popup_menu.js": 346,
	"modules/selected_submission_tags.js": 244,
	"modules/taggable_submission_text.js": 494,
	"modules/tagged_submission_text.js": 791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;